import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import { useMeta } from '../hooks/useMeta';

function NotFound() {
  useMeta({
    title: 'Página no encontrada - Inmaculada Fuentes',
    description: 'La página que buscas no existe. Vuelve al sitio web de Inmaculada Fuentes, autora de libros infantiles.',
    image: '/biografia.png'
  });

  return (
    <div className="app">
      <Navbar showHomeLink />
      <section className="hero">
        <div className="hero-content">
          <h1>404</h1>
          <h2>Página no encontrada</h2>
          <p>Lo sentimos, la página que buscas no existe.</p>
          <Link to="/" className="btn-primary">
            Volver al inicio
          </Link>
        </div>
      </section>
    </div>
  );
}

export default NotFound;